import React from 'react';
const Content = {
    Wrapper: (props) => {
        return (React.createElement("div", { id: "content_wrapper", className: `${props.loading ? 'loading' : ''}`, "data-testid": "content_wrapper" }, props.children));
    },
    Base: (props) => {
        return (React.createElement("div", { className: `content ${props.centered ? 'centered' : ''} ${props.padded ? 'padded' : ''}`, "data-testid": "content_base" }, props.children));
    },
    Header: (props) => {
        return (React.createElement("div", { className: `content_header ${props.className ? props.className : ''}`, "data-testid": "content_header" }, props.children));
    },
};
export default Content;
